module.exports = __webpack_public_path__ + "media/batman@lg-740db9715ef667c0ab7092f734dca993.jpg";